import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
  TextField,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { MyContext } from "../../Context/MyContext";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonsGroup from "./ButtonsGroup";
import { RegisterFormContext } from "../../Context/RegisterFormContext";

export default function ScreenTwo() {
  const { formData, setFormData, three, five, setAvailableScreens } =
    useContext(RegisterFormContext);

  // Handles package selection
  function handlePackageChange(event) {
    const selectedPackage = event.target.value;
    setFormData((prev) => ({
      ...prev,
      package: selectedPackage,
      hours: selectedPackage === "Lesson Plan Package" ? "8-Hour" : "", // Default hours for dropdown
    }));
  }

  // Handles hours selection/input
  function handleHoursChange(event) {
    setFormData((prev) => ({
      ...prev,
      hours: event.target.value,
    }));
  }

  function handlePrev() {
    if (three.current) {
      three.current.scrollIntoView({ behavior: "smooth", block: "center" });

      setTimeout(() => {
        setFormData((prev) => ({
          ...prev,
          package: "",
          hours: 0,
        }))
          setAvailableScreens((prev) => ({ ...prev, screen4: false }));
        }, 500);
    }
  }

  function handleNext() {
    setAvailableScreens((prev) => ({ ...prev, screen5: true }));
    setTimeout(() => {
      if (five.current) {
        five.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  }

  return (
    <div
      style={{
        marginBottom: "1rem",
        minHeight: "80vh",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div>
        <div>
          <Typography
            variant="h6"
            style={{ fontSize: "clamp(1.1rem, 4vw, 2rem" }}
          >
            Select your package:
          </Typography>

          <RadioGroup
            row
            name="package-options"
            value={formData.package || ""}
            onChange={handlePackageChange}
            style={{ display: "flex", gap: "2rem" }}
          >
            <FormControlLabel
              value="Lesson Plan Package"
              control={<Radio />}
              label="Lesson Plan Package"
            />
            <FormControlLabel
              value="Pay As you learn"
              control={<Radio />}
              label="Pay As you learn"
            />
          </RadioGroup>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontSize: "clamp(1.1rem, 4vw, 1.5rem" }}
          >
            {/* {formData.package === "Lesson Plan Package" ? (
              "How many hours:"
            ) : (
              <> */}
                <div>No. Of Credits:</div>
                <div style={{ fontSize: "small" }}>(1 Credit = 1 Hour)</div>
              {/* </>
            )} */}
          </Typography>

          {formData.package === "Lesson Plan Package" ? (
            <Select value={formData.hours} onChange={handleHoursChange}>
              <MenuItem value="8-Hour">8 Credits</MenuItem>
              <MenuItem value="12-Hour">12 Credits</MenuItem>
              <MenuItem value="16-Hour">16 Credits</MenuItem>
            </Select>
          ) : (
            <TextField
              placeholder="Enter Credits"
              type="number"
              value={formData.hours || ""}
              onChange={handleHoursChange}
            />
          )}
        </div>

        <ButtonsGroup
          nextDisabled={!formData.package || !formData.hours}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>
    </div>
  );
}
